import { useAuthStore } from '@/store/authStore';
import { auth, clearTokens } from '@/lib/api-client';
import { getProfile } from '@/api/profile';

export function useAuth() {
  const { profile, isLoading, isInitialized } = useAuthStore();

  async function signUp(email: string, password: string, fullName: string) {
    const result = await auth.signUp(email, password, fullName);
    useAuthStore.getState().setProfile(result.user as any);
    return result;
  }

  async function signIn(email: string, password: string) {
    const result = await auth.signIn(email, password);
    useAuthStore.getState().setProfile(result.user as any);
    return result;
  }

  async function signOut() {
    await auth.signOut();
    clearTokens();
    useAuthStore.getState().reset();
  }

  async function resetPassword(email: string) {
    await auth.resetPassword(email);
  }

  async function refreshProfile() {
    try {
      const profileData = await getProfile();
      useAuthStore.getState().setProfile(profileData);
    } catch {
      // Profile fetch failed
    }
  }

  return {
    profile,
    isLoading,
    isInitialized,
    isAuthenticated: !!profile,
    signUp,
    signIn,
    signOut,
    resetPassword,
    refreshProfile,
  };
}
